// Ensayo de "primera vez" en Tienda online — ADR-2026-10-06-ensayo-de-primera-vez.
//
// Para revisar cómo ve la sección alguien que nunca entró: la lista vacía, las métricas
// sin tiendas conectadas, el popup de la sección y los cartelitos del recorrido.
//
// Sólo en desarrollo. Se prende cargando `/lanzamientos?primeraVez=1` y se apaga con
// `?primeraVez=0` (o cerrando la pestaña). Mientras está prendido, los "ya lo vi" de
// Tienda online (los recorridos `tienda_tour_*` y el anuncio de la sección) se leen y se
// guardan en esta pestaña (`sessionStorage`), NUNCA en `profiles.onboarding_seen`: la
// cuenta real no se toca y el ensayo se puede repetir cuantas veces haga falta.

const CLAVE = 'atlas:ensayo-primera-vez';

/** Las marcas que el ensayo intercepta. El resto del onboarding de la cuenta sigue igual. */
function esDeTiendaOnline(llave: string): boolean {
  return llave.startsWith('tienda_tour_') || llave === 'anuncio:lanzamientos-2026-09';
}

let urlLeida = false;

/**
 * Lee `?primeraVez=` UNA vez por carga de página, la primera vez que alguien pregunta.
 * Así el ensayo ya está decidido cuando el anuncio y los recorridos miran si mostrarse,
 * sin depender de qué componente se monte primero.
 */
function leerUrl(): void {
  if (urlLeida || !import.meta.env.DEV || typeof window === 'undefined') return;
  urlLeida = true;
  const valor = new URLSearchParams(window.location.search).get('primeraVez');
  try {
    if (valor === '1') sessionStorage.setItem(CLAVE, '{}');
    else if (valor === '0') sessionStorage.removeItem(CLAVE);
  } catch {
    /* sin sessionStorage no hay ensayo */
  }
}

function vistos(): Record<string, boolean> | null {
  leerUrl();
  if (!import.meta.env.DEV) return null;
  try {
    const crudo = sessionStorage.getItem(CLAVE);
    return crudo ? (JSON.parse(crudo) as Record<string, boolean>) : null;
  } catch {
    return null;
  }
}

/** ¿Está prendido el ensayo en esta pestaña? */
export function enEnsayo(): boolean {
  return vistos() !== null;
}

/** ¿Esta marca la maneja el ensayo? Si sí, `onboardingSeen` no mira la cuenta. */
export function ensayoCubre(llave: string): boolean {
  return enEnsayo() && esDeTiendaOnline(llave);
}

export function ensayoVisto(llave: string): boolean {
  return vistos()?.[llave] === true;
}

export function ensayoMarcar(llave: string): void {
  const v = vistos();
  if (!v) return;
  try {
    sessionStorage.setItem(CLAVE, JSON.stringify({ ...v, [llave]: true }));
  } catch {
    /* nada que hacer */
  }
}
